import React from "react";

import { styled } from "styled-components";

import { CommunicationStatusBadge } from "pages/communication/components/CommunicationStatusBadge";
import { formatToKST } from "shared/lib/date/formatKst";

export function createCommunicationColumns({
  titleHeader,
  titleMaxLength,
  writerAccessor,
  answererAccessor,
  getStatusType,
  isDone,
  getAnswerTime,
  onDetailClick,
}) {
  return [
    { Header: "No.", accessor: "id" },
    {
      Header: titleHeader,
      accessor: "title",
      Cell: ({ row }) => {
        const title = row.original.title ?? "";
        return title.length > titleMaxLength
          ? title.substring(0, titleMaxLength) + "..."
          : title;
      },
    },
    { Header: "작성자", accessor: writerAccessor },
    {
      // createdAt은 서버가 UTC로 생성하므로 KST로 보정해 표시.
      Header: "게시일",
      accessor: "createdAt",
      Cell: ({ value }) => formatToKST(value),
    },
    {
      Header: "처리여부",
      accessor: "status",
      Cell: ({ row }) => {
        const badgeType = getStatusType(row.original.status);

        return (
          <ButtonDiv>
            <CommunicationStatusBadge type={badgeType} />
          </ButtonDiv>
        );
      },
    },
    {
      Header: "답변자",
      accessor: answererAccessor,
      // 아직 답변자가 없으면(미답변) '-' 표시
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "답변일시",
      accessor: "answerDate",
      Cell: ({ row }) => {
        if (isDone(row.original.status)) {
          // 답변일시(ansTime)도 서버 생성 시각이라 KST로 보정해 표시.
          return <div>{formatToKST(getAnswerTime(row.original))}</div>;
        }

        return (
          <ButtonDiv>
            <AnswerButton
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onDetailClick(row.original.id);
              }}
            >
              답변하기
            </AnswerButton>
          </ButtonDiv>
        );
      },
    },
  ];
}

const AnswerButton = styled.button`
  cursor: pointer;
  width: 74px;
  height: 35px;
  border: none;
  border-radius: 5px;
  background-color: #0079e0;
  color: #ffffff;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 500;
`;

const ButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding-right: 12px;
`;
